module.exports = __webpack_public_path__ + "img/img-43.aaa8719f.png";